import { CSSObject } from "@emotion/serialize";
import type { WidgetDeviceType } from "@intelligems/ig-types";

export function getMediaQuery(
  config: { device: WidgetDeviceType },
  display: string = "flex"
): CSSObject | undefined {
  if (config.device === "desktop") {
    return {
      "@media only screen and (max-width: 600px)": {
        display: "none",
      },
      "@media only screen and (min-width: 601px)": {
        display,
      },
    };
  } else {
    return {
      "@media only screen and (max-width: 600px)": {
        display,
      },
      "@media only screen and (min-width: 601px)": {
        display: "none",
      },
    };
  }
}
